import { render, staticRenderFns } from "./home_3.vue?vue&type=template&id=cb685d8e&scoped=true"
import script from "./home_3.vue?vue&type=script&lang=js"
export * from "./home_3.vue?vue&type=script&lang=js"
import style0 from "./home_3.vue?vue&type=style&index=0&id=cb685d8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb685d8e",
  null
  
)

export default component.exports